package nl.astraeus.wiki.messages

class UpdateWikiTitleMessage() : Message(
  MessageType.UPDATE_WIKI_TITLE,
  MessageHeader.WIKI_ID,
  MessageHeader.WIKI_TITLE,
) {

  constructor(msg: String) : this() {
    message = msg
  }

  constructor(wikiId: Long, title: String) : this() {
    setHeader(MessageHeader.WIKI_ID, wikiId.toString())
    setHeader(MessageHeader.WIKI_TITLE, title)
  }

}
